<template>
  <InitCourseModal
    v-if="showInitCourseModal"
    :courseId="courseIdSelected"
    @closeModal="closedInitCourseModal"
  />
  <LoadingData v-if="loadData" />
  <div v-if="courses.inProgress.length > 0">
    <h5>Cursos em andamento</h5>
    <div class="row">
      <div
        v-for="course in courses.inProgress"
        :key="course.id"
        class="col-lg-3 col-md-4 col-sm-6 mb-3"
      >
        <CardCourse
          :course="course"
          borderColor="primary"
          :showStatus="false"
          :showProgress="true"
        >
          <router-link
            :to="`/courses/${course.id}/progress`"
            title="Continuar Curso"
          >
            <span class="badge bg-success">Continuar Curso</span>
          </router-link>
        </CardCourse>
      </div>
    </div>
  </div>
  <div v-if="courses.notStarted.length > 0">
    <h5>Cursos não iniciados</h5>
    <div class="row">
      <div
        v-for="course in courses.notStarted"
        :key="course.id"
        class="col-lg-3 col-md-4 col-sm-6 mb-3"
      >
        <CardCourse
          :course="course"
          borderColor="secondary"
          :showStatus="false"
          :showProgress="false"
        >
          <router-link
            :to="`/courses/${course.id}`"
            title="Visualizar detalhes do curso"
          >
            <span class="badge bg-primary">Detalhes do Curso</span>
          </router-link>
          <span
            role="button"
            class="badge bg-success ms-2"
            title="Iniciar Curso"
            @click="initCourse(course.id)"
          >
            Iniciar Curso
          </span>
        </CardCourse>
      </div>
    </div>
  </div>
  <div v-if="courses.done.length > 0">
    <h5>Cursos concluídos</h5>
    <div class="row">
      <div
        v-for="course in courses.done"
        :key="course.id"
        class="col-lg-3 col-md-4 col-sm-6 mb-3"
      >
        <CardCourse
          :course="course"
          borderColor="success"
          :showStatus="false"
          :showProgress="false"
        >
          <router-link
            :to="`/courses/${course.id}/progress`"
            title="Acessar Curso"
          >
            <span class="badge bg-success">Acessar Curso</span>
          </router-link>
          <span
            role="button"
            class="badge bg-secondary ms-2"
            title="Baixar certificado"
            @click="getCertificate(course.key)"
          >
            Certificado
          </span>
        </CardCourse>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import InitCourseModal from '@/components/progress/InitCourseModal.vue'
import CardCourse from '@/components/commons/CardCourse.vue'
import createCertificate from '@/utils/certificate'

export default {
  name: 'CoursesUser',

  components: {
    LoadingData,
    InitCourseModal,
    CardCourse,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showInitCourseModal: false,
      courses: {
        inProgress: [],
        notStarted: [],
        done: [],
      },
      courseIdSelected: null,
    }
  },

  methods: {
    async getCoursesUser() {
      try {
        this.courses = await this.$store.dispatch('getCoursesUser', this.userId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    initCourse(courseId) {
      this.courseIdSelected = courseId
      this.showInitCourseModal = true
    },

    closedInitCourseModal(redirect) {
      this.showInitCourseModal = false
      if (redirect) {
        this.$router.push({
          name: 'ProgressCourse',
          params: { courseId: this.courseIdSelected },
        })
      }
    },

    async getCertificate(key) {
      try {
        const dataCertificate = await this.$store.dispatch(
          'getCertificateAuth',
          key,
        )

        createCertificate({
          certificate: dataCertificate,
          type: 'download',
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getCoursesUser()
  },
}
</script>
